export const PAYMENT_METHOD_CREDIT_CARD_STATUS_ENUM = {
  ACTIVE: 'ACTIVE', // initialized and not confirmed
  AUTHORIZED: 'AUTHORIZED', // authorized only
  CAPTURED: 'CAPTURED', // transaction captured
  COMPLETED: 'COMPLETED', // auth, capture and paid,
  FAILED: 'FAILED', // rejected or failed
  CANCELED: 'CANCELED', // canceled
  CHARGEBACK: 'CHARGEBACK', // chargeback
};
